import { tabsAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { FONT_WEIGHTS } from '../tokens';

// Styles
const {
  definePartsStyle,
  defineMultiStyleConfig,
} = createMultiStyleConfigHelpers(tabsAnatomy.keys);

// Exports
export const Tabs = defineMultiStyleConfig({
  baseStyle: definePartsStyle({
    tab: {
      pl: '0',
      pr: '0',
      minW: '100px',
      mr: 10,
      mt: 10,
      _selected: {
        fontWeight: FONT_WEIGHTS.bold,
        borderBottom: '2px',
      },
    },
  }),
});
